import { render } from "./PrivacyPolicy.vue?vue&type=template&id=ceceb8ee&scoped=true"
const script = {}

import "./PrivacyPolicy.vue?vue&type=style&index=0&id=ceceb8ee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ceceb8ee"]])

export default __exports__